import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const ConsumerCibilDownloadModalUI = ({
  context, successMsg, errorList, setErrorList,
  // modes
  downloadMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
  //
  reportingRangeCode, onReportingRangeChange, reportingRangeError, setReportingRangeError, reportingRangeList,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Download Consumer Cibil Until Date'
    buttonLabel='Download'
    cancelLabel='Cancel'
    isOpen={downloadMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='select' name='reportingRange'
      label='Reporting period'
      value={reportingRangeCode} onChange={onReportingRangeChange} optionList={reportingRangeList}
      error={reportingRangeError} setError={setReportingRangeError}
    />
  </ModalFormUI>

export default ConsumerCibilDownloadModalUI

